import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UnsavedChangesComponent } from './unsaved-changes.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [UnsavedChangesComponent],
  exports: [UnsavedChangesComponent],
  imports: [CommonModule, MatDialogModule, MatButtonModule],
})
export class UnsavedChangesModule {}
